import { Component, OnInit, effect, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SupabaseService } from '../../shared/services/supabase.service';

@Component({
  selector: 'app-sign-in',
  standalone: true,
  imports: [],
  templateUrl: './sign-in.component.html'
})
export class SignInComponent implements OnInit {
  private supabase = inject(SupabaseService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  isLoading = signal(false);
  errorMessage = signal<string | null>(null);

  constructor() {
    // Redirect to home when session is established (handles OAuth callback via onAuthStateChange)
    effect(() => {
      if (this.supabase.session()) {
        this.router.navigateByUrl('/');
      }
    });
  }

  ngOnInit(): void {
    const hasError = !!this.route.snapshot.queryParams['error'] ||
      !!new URLSearchParams(window.location.hash.slice(1)).get('error');

    if (hasError) {
      this.errorMessage.set('La connexion Microsoft a échoué. Veuillez réessayer.');
    }
  }

  async onLoginMicrosoft(): Promise<void> {
    this.isLoading.set(true);
    this.errorMessage.set(null);
    const { error } = await this.supabase.signInWithMicrosoft();
    if (error) {
      this.errorMessage.set('Une erreur est survenue. Veuillez réessayer.');
      this.isLoading.set(false);
    }
    // On success, Supabase redirects to Microsoft login page
  }
}
